const getters = {
    updateStore: state => state.app.isLogin,
    updateNav: state => state.app.routeArr,
  }
export default getters